export default __webpack_public_path__ + "static/media/numbers.cbe1dc9d.png";